import React from 'react';

import BaseClass from '@/pages/BaseClass';

import {CommonValue, getQuery, httpPost, pcUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            'courseId': 0,
            'nodeId': 0,
            'selectedIndex': 0,

            'courseIds': [],
            'courseIndex': 0,

            'info': {
                'studyProcessList': [],
            },
        };
    }

    componentDidMount() {
        let courseId = this.props.match.params.id;
        this.state.courseId = courseId;

        let nodeId = getQuery('id');
        if (nodeId)
            this.state.nodeId = nodeId;
        this.getInfo();

        let courseIds = CommonValue.get('course_ids');
        let courseIndex = courseIds.findIndex(id => +courseId == id);

        this.setState({courseIds, courseIndex});

        //视频播放结束，自动播放下一节视频
        this.videoRef.addEventListener('ended', () => {
            if (this.state.selectedIndex < this.state.info.studyProcessList.length - 1) {
                this.playVideo(this.state.selectedIndex + 1);
            } else {
                this.updatePlayTime();
            }
        });
    }

    getInfo() {
        let url = pcUrl('/study/course/' + this.state.courseId);
        httpPost(url, {}, 'GET')
            .then(data => {
                this.setState({
                    'info': data,
                }, () => {
                    if (data.studyProcessList.length) {
                        if (!this.state.nodeId)
                            this.playVideo(0, true);
                        else {
                            let index = data.studyProcessList.findIndex(row => row.nodeId == this.state.nodeId);

                            this.setState({
                                'selectedIndex': index,
                            });
                            this.playVideo(index, true);
                        }
                    }
                });
            });
    }

    playVideo(index, needInit) {
        if (this.videoRef.played && this.videoRef.played.length > 0) {
            this.updatePlayTime();
        }

        this.setState({
            'selectedIndex': index,
        });

        let nodeInfo = this.state.info.studyProcessList[index];
        this.videoRef.src = "https://vod.jscqe.com/" + nodeInfo.videoUrl;
        if (needInit) {
            this.videoRef.currentTime = nodeInfo.studyTime;
        }

        this.videoRef.play();
    }

    //更新播放时间
    updatePlayTime() {
        if (!this.videoRef.played || this.videoRef.played.length === 0)
            return;

        let index = this.state.selectedIndex;
        let playTime = this.videoRef.currentTime;
        let studyInfo = this.state.info.studyProcessList[index];
        let studyTime = studyInfo.studyTime || 0;
        if (playTime > studyTime) {
            // 立即同步更新 studyTime，防止竞态重复上报
            studyInfo.studyTime = playTime;

            let url = pcUrl('/study/course/process');
            let param = {
                "courseId": studyInfo.courseId, // 课题ID
                "nodeId": studyInfo.nodeId, // 课节ID
                "studyTime": Math.ceil(playTime) // 学习时长
            };

            httpPost(url, param)
                .catch(() => {
                    // 请求失败时回滚，允许下次重试
                    studyInfo.studyTime = studyTime;
                });
        }
    }


    //上一课
    // prevCourse() {
    //     if (this.state.courseIndex == 0)
    //         return false;
    //
    //     let courseId = this.state.courseId;
    //     let courseIndex = this.state.courseIndex;
    //
    //     courseId = this.state.courseIds[--courseIndex];
    //     this.setState({
    //         courseId,
    //         courseIndex,
    //         'nodeId': 0,
    //     }, () => {
    //         this.getInfo();
    //     });
    // }
    //
    // //下一课
    // nextCourse() {
    //     if (this.state.courseIndex == this.state.courseIds.length - 1)
    //         return false;
    //
    //     let courseId = this.state.courseId;
    //     let courseIndex = this.state.courseIndex;
    //
    //     courseId = this.state.courseIds[++courseIndex];
    //     this.setState({
    //         courseId,
    //         courseIndex,
    //         'nodeId': 0,
    //     }, () => {
    //         this.getInfo();
    //     });
    // }

    render() {
        return (
            <>
                <div className="player">
                    <div className="player-left">
                        <div className="player-head">
                            {this.state.info.courseName}
                        </div>
                        <video ref={e => this.videoRef = e} autoplay controls controlsList="nodownload"></video>
                    </div>
                    <div className="player-right">
                        {/*<div className="player-head">*/}
                        {/*    {this.state.courseIndex > 0 && (*/}
                        {/*        <a href="javascript:;" className="button" onClick={() => this.prevCourse()}>上一课</a>*/}
                        {/*    )}*/}

                        {/*    {this.state.courseIndex < this.state.courseIds.length - 1 && (*/}
                        {/*        <a href="javascript:;" className="button" onClick={() => this.nextCourse()}>下一课</a>*/}
                        {/*    )}*/}
                        {/*</div>*/}
                        <div className="player-category">
                            <h3>课题目录</h3>
                            <ul>
                                {this.state.info.studyProcessList.map((row, index) => (
                                    <li>
                                        <a href="javascript:;"
                                           className={this.state.selectedIndex == index ? 'now' : ''}
                                           onClick={() => this.playVideo(index)}>
                                            {row.nodeName}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

